/** ATP wizard + program view — shared phase/model definitions (mirrors mobile ATP screen). */

export interface AtpPhaseDef {
  key: string;
  label: string;
  color: string;
}

export const ATP_PHASES: AtpPhaseDef[] = [
  { key: 'base', label: 'Base', color: '#4A7BE5' },
  { key: 'b1', label: 'Build 1', color: '#1FAE63' },
  { key: 'b2', label: 'Build 2', color: '#EA580C' },
  { key: 'peak', label: 'Peak', color: '#DC2626' },
  { key: 'taper', label: 'Taper', color: '#64748B' },
];

export const TRAINING_MODELS = [
  {
    key: 'traditional',
    label: 'Traditional',
    desc: 'Base → Build → Peak. Progressive load with strong aerobic foundation.',
    emoji: '🏆',
  },
  {
    key: 'reverse',
    label: 'Reverse',
    desc: 'Intensity first, then volume. For time-limited athletes.',
    emoji: '🔄',
  },
  {
    key: 'polarized',
    label: 'Polarized',
    desc: '80% Z1–Z2 and 20% Z4–Z5. Research-backed approach.',
    emoji: '⚡',
  },
  {
    key: 'pyramidal',
    label: 'Pyramidal',
    desc: 'Descending volume by zone. Common elite methodology.',
    emoji: '📐',
  },
] as const;

export type TrainingModelKey = (typeof TRAINING_MODELS)[number]['key'];

export const DEFAULT_PHASE_WEEKS: Record<string, number[]> = {
  base: [450, 490, 530, 340, 510, 550, 590, 370, 560, 600, 640, 400, 610, 650, 690, 430],
  b1: [660, 710, 760, 480, 730, 780, 830, 520],
  b2: [810, 860, 910, 580],
  peak: [880, 900, 860, 800],
  taper: [620, 380],
};

export const DEFAULT_PHASE_COUNTS: Record<string, number> = {
  base: 16,
  b1: 8,
  b2: 4,
  peak: 4,
  taper: 2,
};

export const WIZARD_STEP_TITLES = [
  'Initial Info',
  'Races',
  'CTL Target',
  'Training Model',
  'TSS Review',
  'Confirm & Build',
] as const;

export const TOTAL_WIZARD_STEPS = WIZARD_STEP_TITLES.length;
